import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import useLocalStorage from 'hooks/use-local-storage'
import { getCurrentMasterDetails } from 'services/master'
import { Master } from 'services/types/auth'
import { MasterResponse } from 'services/types/master'
import { STALE_TIME } from 'utils/constants'
import { masterKey } from 'utils/constants/queryKey'

export const useMasterDetails = (options?: AppQueryOptions<MasterResponse>) => {
  const token = localStorage.getItem('token') ?? ''
  return useAppQuery(masterKey.detail(token), () => getCurrentMasterDetails(), {
    enabled: !!token,
    staleTime: STALE_TIME.masterSetting,
    ...options,
  })
}

export const useLoginMaster = () => useLocalStorage<Master | null>('master', null)
